export const enum CricketResultId {
  Results = 2,
  Wickets = 200,
  Overs = 201,
  CurrentOver = 582,
  CurrentBall = 1213,
  FirstInningRuns = 570,
  SuperOverResult = 1363,
}
